import { useState } from "react";
import { useEffect } from "react";
import { connect } from "react-redux";

import { createNewKPI } from "../../../data/omniDataModel.js";
import * as UserSession from "../../../state/redux/userSession.js";
import { deepCopyObject } from "../../../utils/helpers.js";
import EmpireKPIDialog from "../../dialogs/empireKPIDialog.js";
import OmniUserInputDialog from "../../dialogs/omniUserInputDialog.js";
import EmpireKPIListItem from "../../ui/empireKPIListItem.js";
import OmniResponsiveButton from "../../ui/omniResponsiveButton.js";
import Widget from "../../ui/widget.js";
import WidgetList from "../../ui/widgetList.js";
import WidgetSkeleton from "../../ui/widgetSkeleton.js";
import WidgetTitle from "../../ui/widgetTitle.js";

const EmpireKPI = props => {
  const { userKPIs, userODM, title = "Key Process Indicators", updateUserKPIRequest } = props;

  const [selectedKPI, setSelectedKPI] = useState(null);
  const [valueEntry, setValueEntry] = useState(null);

  const [titleText, setTitleText] = useState("test");
  // const [valueEntry, setShowValueEntry] = useState(null);

  useEffect(() => {
    if (userKPIs != null) {
      setTitleText(`Tracking ${userKPIs.length} KPI${userKPIs.length === 1 ? "" : "s"}`);
    } else setTitleText("");
  }, [userKPIs]);

  return (
    <Widget>
      <WidgetTitle title={title} text={titleText} loading={userKPIs == null}>
        <OmniResponsiveButton
          tooltipTitle="Create A Shared Invite"
          component="label"
          buttonText={"Create"}
          onClick={() => {
            let newKPI = createNewKPI();
            newKPI.omniData.businessPillar = userODM.omniData.businessPillar;

            setSelectedKPI(newKPI);
          }}
        ></OmniResponsiveButton>
      </WidgetTitle>

      {userKPIs == null && <WidgetSkeleton />}
      {userKPIs != null && (
        <WidgetList>
          {userKPIs
            .sort(
              (a, b) =>
                a.omniData.businessPillar.localeCompare(b.omniData.businessPillar) ||
                a.omniData.name.localeCompare(b.omniData.name),
            )
            .map((kpi, index) => {
              return (
                <EmpireKPIListItem
                  key={kpi + index}
                  kpiODM={kpi}
                  onClickHandler={setSelectedKPI}
                  onAddEntryHandler={theKPI => setValueEntry(theKPI)}
                />
              );
            })}
        </WidgetList>
      )}
      {selectedKPI != null && (
        <EmpireKPIDialog
          open={selectedKPI != null}
          omniODM={selectedKPI}
          dialogTitle={selectedKPI._id == null ? "Create KPI" : "Edit KPI"}
          onAccept={kpiODM => {
            updateUserKPIRequest(kpiODM);
            setSelectedKPI(null);
          }}
          onClose={() => {
            setSelectedKPI(null);
          }}
        />
      )}

      {valueEntry && (
        <OmniUserInputDialog
          inputLabel={`Week ${valueEntry.omniData.values.length + 1} Value`}
          open={valueEntry}
          unitsLabel={valueEntry.omniData.postUnitLabel}
          dialogTitle={`${valueEntry.omniData.name}`}
          dialogMessage={`What is the latest ${valueEntry.omniData.name} KPI value?`}
          // dialogMessage={"Please enter the KPI value for this week"}
          onAccept={theValue => {
            try {
              let newODM = deepCopyObject(valueEntry);
              theValue = theValue.replace(/[^0-9]/g, "");
              valueEntry.kpiValue = theValue;

              newODM.omniData.values.push(valueEntry);
              updateUserKPIRequest(newODM);
            } catch (error) {
              console.log(error);
            }
            setValueEntry(null);
          }}
          onClose={() => {
            setValueEntry(null);
          }}
        />
      )}
    </Widget>
  );
};

const mapStateToProps = state => ({
  userKPIs: state.userSession.userKPIs,
  userODM: state.userSession.userODM,
});

const mapDispatchToProps = {
  updateUserKPIRequest: UserSession.updateUserKPIRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(EmpireKPI);
